module.exports = ".setting-input{\r\n    width: 50px;\r\n}"